<div id="video-banner-container">
    <video autoplay muted loop>
        <source [src]="bannerVideo().videoSrc">
    </video>
    <div class="video-banner-dark-overlay"></div>
    <div id="video-banner-overlay">
        <h3 class="video-banner-subtitle">{{bannerVideo().subtitle}}</h3>
        <h2 class="video-banner-title" >{{bannerVideo().title}}</h2>
        <img class="video-banner-title-img" [class]="{'video-banner-title-short': !bannerVideo().titleImgRoute.includes('dock3')}" [src]="bannerVideo().titleImgRoute">
        <h4 class="video-banner-subsubtitle">{{bannerVideo().subsubtitle}}</h4>
    </div>


</div>